import { formatCurrency, stateOptions } from "uikit"
import React from "react"
import { NavLink } from "react-router-dom"
import { Card, Grid, Icon } from "semantic-ui-react"
import { useStore } from "store"

const PropertyName = ({ householdId }) => {
  const [properties] = useStore("householdProperties", householdId)

  const property = Object.values(properties).find(
    property => property.is_primary_residence
  )
  return <span>{property ? property.description : ""}</span>
}

const Household = ({
  id,
  primary_state_of_residence,
  is_renter,
  monthly_rent,
  baseUrl
}) => {
  const primaryState = stateOptions.find(
    ({ value }) => value === primary_state_of_residence
  )
  return (
    <Card>
      <Card.Content>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column textAlign="left">
              <NavLink to={`${baseUrl}/household`} className="navlink">
                <span className="GenericCard__LinkTitle">
                  Residency
                  <Icon name="chevron right" size="small" />
                </span>
              </NavLink>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <span className="GenericCard__Balance">
                {primaryState ? primaryState.text : ""}
              </span>
              <p className="greyed-text">primary state of residence</p>
            </Grid.Column>
          </Grid.Row>
          {is_renter !== null && (
            <Grid.Row columns={2}>
              <Grid.Column textAlign="left" verticalAlign="bottom">
                <p className="greyed-text">
                  {is_renter ? "Renting" : "Primary residence"}
                </p>
              </Grid.Column>
              <Grid.Column textAlign="right">
                {is_renter ? (
                  `${formatCurrency(monthly_rent)}`
                ) : (
                  <PropertyName householdId={id} />
                )}
                <p className="greyed-text">{is_renter ? `monthly rent` : ``}</p>
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      </Card.Content>
    </Card>
  )
}

export default Household
